import React, { useEffect, useState } from "react";
import { useSidebar } from "../context/SidebarContext";
import WalletTabs from "./WalletTabs";
import { useWallet } from "../context/WalletContext";
import {  SERVER_URL} from "../utils/constants";
import { formatAddress } from "../utils/formatAddress";
import { useUserStore } from "../stores/useUserStore";
import axios from "axios";


interface SidebarProps {
    isOpen: boolean;
    onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const { account, networkId, isConnected, connectWallet, disconnectWallet } = useWallet();

    const [nativeBalance, setNativeBalance] = useState("0");
    const [tokenBalance, setTokenBalance] = useState("0");
    const tokenAmount = useUserStore((s) => s.token);
    const balanceAmount = useUserStore((s) => s.balance);
    const setUser = useUserStore((s) => s.setUser);

    const loadBalances = async (account: string) => {
        try{
            const res: any = await axios.post(`${SERVER_URL}/api/getBalanceAccount`, {
                address: account
            });
            const data = res.data;
            setUser({
                balance: Number(data.nativeBalance).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
                token: Number(data.tokenBalance).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
            });
        }catch(e){
            console.log(e);
        }
       
    };

    useEffect(() => {
        if (account && isConnected) {
            loadBalances(account);
        }
    }, [account, isConnected]);

    return (
        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
            <div className="sidebar-content">
                <div className="sidebar-header">
                    <button className="close-btn color-primary" onClick={toggleSidebar}>✖</button>
                    <button className="wallet-button">
                        <img alt="Wallet Icon" className="wallet-icon" src="images/crypto/icons/wallet.png" />
                        <span className="wallet-text">{formatAddress(account ?? '')}</span>
                    </button>
                </div>
                <hr className="color-primary" />
                <div className="sidebar-content">
                    <div className="d-flex">

                        <button className="wallet-action mr-5">
                            <img src="images/crypto/networks/bsc.png" alt="Buy" className="icon" />
                            <span>{(account && isConnected) ? balanceAmount : (<i className="fa fa-spinner fa-spin"></i>)}</span>
                        </button>

                        <button className="wallet-action">
                            <img src="images/crypto/logo.png" alt="Buy" className="icon" />
                            <span>{(account && isConnected) ? tokenAmount : (<i className="fa fa-spinner fa-spin"></i>)}</span>
                        </button>
                    </div>
                    <hr className="color-primary" />


                    <WalletTabs />
                </div>



            </div>
        </div>
    );
};

export default Sidebar;
